<template>
  <div class="p-6 rounded-lg bg-white flex flex-col min-h-full">
    <h1 class="text-2xl md:text-3xl font-bold text-gray-900 text-center">
      Bem-vindo ao CISA
    </h1>
    <p class="text-gray-800 text-sm md:text-base text-center mb-8">
      Faça login para gerenciar suas avaliações de segurança.
    </p>

    <!-- Botões como Abas -->
    <div class="flex justify-center bg-gray-100 rounded-t-lg">
      <button v-for="(tab, index) in tabs" :key="index" @click="activeTab = tab.name"
        class="text-xs py-1 px-3 font-semibold focus:outline-none transition duration-300 shadow-md rounded-t-lg"
        :class="{
          'bg-white border-b-4 border-blue-500 text-blue-600':
            activeTab === tab.name,
          'text-gray-600 hover:bg-gray-200': activeTab !== tab.name,
        }">
        {{ tab.label }}
      </button>
    </div>

    <!-- Conteúdo das Abas -->
    <div class="px-3 py-2 rounded-b-lg bg-white flex-grow overflow-y-auto min-h-[300px]">
      <component :is="activeComponent" />
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/users/UsersLoginForm.vue'
import RecoverForm from '@/components/users/UsersRecoverForm.vue'
import { markRaw } from 'vue'

export default {
  components: {
    LoginForm: markRaw(LoginForm),
    RecoverForm: markRaw(RecoverForm),
  },
  data() {
    return {
      activeTab: 'login',
      tabs: [
        { name: 'login', label: 'Login', component: LoginForm },
        { name: 'recover', label: 'Recuperar Senha', component: RecoverForm },
      ],
    }
  },
  computed: {
    activeComponent() {
      return (
        this.tabs.find((tab) => tab.name === this.activeTab)?.component ||
        LoginForm
      )
    },
  },
}
</script>

<style scoped>
button {
  min-width: 120px;
  text-align: center;
}

button:active {
  transform: scale(0.98);
}

button:hover {
  background-color: #e5e7eb;
}

div.p-4 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-grow: 1;
  height: auto;
}

.text-gray-800 {
  color: #2d3748;
}

.text-blue-600 {
  color: #3182ce;
}

.bg-gray-100 {
  background-color: #f7fafc;
}

.bg-white {
  background-color: white;
}

.shadow-md {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.rounded-b-lg {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
</style>
